import React, { useContext } from 'react';
import { Row } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import DeviceItem from './DeviceItem';

const DeviceList = observer(() => {
    const { device } = useContext(Context);

    if (device.devices.length === 0) {
        return <div className="text-center mt-4">Нет товаров</div>;
    }

    return (
        <Row className="d-flex">
            {device.devices.map(device => (
                <DeviceItem key={device.id} device={device} />
            ))}
        </Row>
    );
});

export default DeviceList;